import { API_PATH } from "api/ApiPath";
import { BaseApiResponseModel } from "api/baseApiResponseModel/BaseApiResponseModel";
import client from "api/client";
import { ChangePasswordRequestModel } from "./model/ChangePasswordRequestModel";

export interface IChangePasswordRepository {
  changePassword(
    body: ChangePasswordRequestModel
  ): Promise<BaseApiResponseModel<any>>;
}

class ChangePasswordImpl implements IChangePasswordRepository {
  async changePassword(
    body: ChangePasswordRequestModel
  ): Promise<BaseApiResponseModel<any>> {
    const payload = {
      currentPassword: (body as any).currentPassword ?? (body as any).oldPassword,
      newPassword: body.newPassword,
    };
    return await client?.post(API_PATH.CHANGE_PASS, payload);
  }
}

export const defaultChangePasswordRepository = new ChangePasswordImpl();
